import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Spread } from "../api/agent.api";
import { BaseResource } from "@kgsport-cms/common";
import "../common";
export var AspreadService = /*#__PURE__*/function (_BaseResource) {
  _inherits(AspreadService, _BaseResource);
  var _super = _createSuper(AspreadService);
  function AspreadService() {
    _classCallCheck(this, AspreadService);
    return _super.apply(this, arguments);
  }
  _createClass(AspreadService, [{
    key: "promoteList",
    value: function promoteList(params) {
      return this.requester.get(Spread.linkList, {
        params
      });
    }
    // 获取彩票等级
  }, {
    key: "lotteryRebates",
    value: function lotteryRebates(params) {
      return this.requester.get(Spread.lotteryRebates, {
        params
      });
    }
    // 推广类型
  }, {
    key: "promotType",
    value: function promotType() {
      return this.requester.get(Spread.promotType);
    }
    // 新增推广码
  }, {
    key: "addInviteCode",
    value: function addInviteCode(params) {
      return this.requester.get(Spread.addInviteCode, {
        params
      });
    }
    // 推广码配置
  }, {
    key: "inviteCodeConfig",
    value: function inviteCodeConfig() {
      return this.requester.get(Spread.inviteCodeConfig);
    }
    // 推广码删除
  }, {
    key: "inviteCodeDelete",
    value: function inviteCodeDelete(params) {
      return this.requester.get(Spread.inviteCodeDelete, {
        params
      });
    }
    // 获取推广域名
  }, {
    key: "promoteDomainList",
    value: function promoteDomainList() {
      return this.requester.get(Spread.promoteDomainList);
    }
    // mango邀请和奖励地址
  }, {
    key: "getSpreadLink",
    value: function getSpreadLink() {
      return this.requester.get(Spread.getSpreadLink);
    }
    // mango邀请数据和配置
  }, {
    key: "getReport",
    value: function getReport(params) {
      return this.requester.get(Spread.getReport, {
        params
      });
    }
  }]);
  return AspreadService;
}(BaseResource);